
    <div fxLayout="row" class="full-height ">
      <mat-card class="auth" fxLayout="column">
        <div class="logo">
          <div fxLayout="row" fxLayoutAlign="center center" class="full-height">
            <img
              src="../../../../assets/logos/logo_2.png"
              alt="Ml Dickes Logo"
            />
          </div>
        </div>
        <div
          fxLayout="column"
          fxLayoutAlign="flex-start center"
          class="full-width full-height auth-container"
        >
          <ng-content></ng-content>
        </div>
      </mat-card>
    </div>
  